(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s360-sticky-buy"] && !Shopify.designMode) return;
  try {
    function setupSystem360Purchase(){
 document.querySelectorAll('[data-s360-buy]').forEach(bar=>{
  if(bar.dataset.ready)return;
  const form=document.getElementById('product-form-'+bar.dataset.s360Buy);
  const primary=form?.querySelector('button[name="add"]');
  const button=bar.querySelector('button');
  if(!form||!primary){bar.hidden=true;return;}
  bar.dataset.ready='true';
  if('IntersectionObserver' in window)new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting;},{threshold:.3}).observe(primary);
  const sync=()=>{button.disabled=primary.disabled||primary.getAttribute('aria-disabled')==='true';};
  new MutationObserver(sync).observe(primary,{attributes:true,attributeFilter:['disabled','aria-disabled']});
  sync();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupSystem360Purchase);else setupSystem360Purchase();
document.addEventListener('shopify:section:load',setupSystem360Purchase);
  } catch(e) { console.error(e); }
})();

})();
